// extracted by mini-css-extract-plugin
module.exports = {"simpleLayout":"SimpleLayout_simpleLayout__2V5yY"};